import { DynamicObject } from './commonTypes';
import { HTTP_HEADER_KEYS } from './constants/HttpMethodsConstants';
import { SingleLaunchResponse } from '../services/responseTypes/singleLaunchResponse';
import { XtraApiResponse } from '../services/responseTypes/xtraApiResponse';
import SimpleStore from '../store/SimpleStore';

export const validateInitialDataOnServer = (
  singleLaunchData: SingleLaunchResponse,
  locationRes: XtraApiResponse,
  translations: DynamicObject | undefined
): boolean => {
  if (!singleLaunchData || !locationRes || !translations) {
    return false;
  }
  const validateTypes = {
    object: (value: DynamicObject): boolean =>
      !!(typeof value === 'object' && Object.keys(value).length),
    array: (value: DynamicObject): boolean =>
      !!(Array.isArray(value) && Object.keys(value).length),
    string: (value: string): boolean => !!(typeof value === 'string' && value)
  };

  const { countrylist, getlang, platform_token } = singleLaunchData;
  const validateItems = [
    validateTypes.array(countrylist),
    validateTypes.object(locationRes),
    validateTypes.object(translations),
    validateTypes.object(getlang),
    validateTypes.object(platform_token)
  ];
  if (
    validateItems.every((item) => item === true) &&
    validateTypes.string(platform_token.token)
  ) {
    SimpleStore.set(
      HTTP_HEADER_KEYS.X_ACCESS_TOKEN,
      platform_token.token || ''
    );
    return true;
  }

  return false;
};
